import { NgModule } from '@angular/core';
import { CsInputMeasureComponent } from 'components/cs-input-measure/cs-input-measure';
import { CsSelectPopover } from 'components/cs-select-popover/cs-select-popover';
import { InputPairNavigationDirective } from 'directives/input-pair-navigation.directive';
import { HintBubbleComponent } from 'components/hint-bubble/hint-bubble';
import { InputCalendarComponent } from 'components/input-calendar/input-calendar';
import { AddMacrosPopover } from 'components/add-macros-popover/add-macros-popover';
import { ReschedulePopover } from 'components/reschedule-popover/reschedule-popover';
import { CsViewNotesPopover } from 'components/cs-view-notes-popover/cs-view-notes-popover';
import { CsLogDetailPopover } from 'components/cs-log-detail-popover/cs-log-detail-popover';
import { CsLogDetailContent } from 'components/cs-log-detail-content/cs-log-detail-content';
import { CsTabContentContainer } from 'components/cs-tab-content/cs-tab-content-container';
import { CsTabContent } from 'components/cs-tab-content/cs-tab-content';
import { CsTextarea } from 'components/cs-textarea/cs-textarea';
import { HelpIconComponent } from 'components/help-icon/help-icon';
import { HelpLinkComponent } from 'components/help-link/help-link';
import { VldMessageComponent } from 'components/vld-message/vld-message';
import { IngredientList } from './ingredient-search/ingredient-list';
import { CsRecentMealsEmptyStateComponent } from './ingredient-search/recent-meals-empty-state';
import { ImageUploaderComponent } from './image-uploader/image-uploader';
import { NutrientListComponent } from 'components/nutrient-list/nutrient-list';
import { MeasuresListComponent } from './measures-list/measures-list';
import { MarkdownEditorComponent } from 'components/markdown-editor/markdown-editor';
import { CsTextSpinnerComponent } from './cs-text-spinner/cs-text-spinner';
import { ToastHostComponent } from './toast/toast-host';
import { CsIconComponent } from './cs-icon/cs-icon';
import { CsSpinnerComponent } from './cs-spinner/cs-spinner';
import { CsCameraViewComponent } from './cs-camera-view/cs-camera-view';
import { CsScannerProgressBarComponent } from './cs-scanner-progress-bar/cs-scanner-progress-bar';
import { CsRepProgressBarComponent } from './cs-rep-progress-bar/cs-rep-progress-bar';
import { CsScannerAnalyzingOverlayComponent } from './cs-scanner-analyzing-overlay/cs-scanner-analyzing-overlay';
import { CsScannerCameraStageComponent } from './cs-scanner-camera-stage/cs-scanner-camera-stage';
import { CsScannerShutterBarComponent } from './cs-scanner-shutter-bar/cs-scanner-shutter-bar';
import { CsScannerPhotoReelComponent } from './cs-scanner-photo-reel/cs-scanner-photo-reel';
import { CsScannerHintsComponent } from './cs-scanner-hints/cs-scanner-hints';
import { CsScannerPermissionDeniedComponent } from './cs-scanner-permission-denied/cs-scanner-permission-denied';
import { CsScannerModelPickerComponent } from './cs-scanner-model-picker/cs-scanner-model-picker';
import { CsBarcodeTrackerOverlayComponent } from './cs-barcode-tracker-overlay/cs-barcode-tracker-overlay';
import { CsSkeletonComponent } from './cs-skeleton/cs-skeleton';
import { CsCheckboxComponent } from './cs-checkbox/cs-checkbox';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog';
import { CsMarkdownComponent } from './cs-markdown/cs-markdown';
import { CsCardComponent } from './cs-card/cs-card';
import { CsCardListComponent } from './cs-card-list/cs-card-list';
import { CsCardListRowComponent } from './cs-card-list-row/cs-card-list-row';
import { CsCardTitleComponent } from './cs-card/cs-card-title';
import { CsCardHeaderComponent } from './cs-card/cs-card-header';
import { CsCardContentComponent } from './cs-card/cs-card-content';
import { CsNoteComponent } from './cs-note/cs-note';
import { CsItemComponent } from './cs-item-list/cs-item';
import { CsItemListComponent } from './cs-item-list/cs-item-list';
import { CsItemGroupComponent } from './cs-item-list/cs-item-group';
import { CsItemDividerComponent } from './cs-item-list/cs-item-divider';
import { CsContentDividerComponent } from './cs-item-list/cs-content-divider';
import { CsTooltipComponent } from './cs-tooltip/cs-tooltip';
import { CsTooltipPopover } from './cs-tooltip/cs-tooltip-popover';
import { CsItemListHeaderComponent } from './cs-item-list/cs-item-list-header';
import { CsLabelComponent } from './cs-label/cs-label';
import { CsFormField } from './cs-form-field/cs-form-field';
import { CsToggleComponent } from './cs-toggle/cs-toggle';
import { CsSkinfoldSiteMeasureComponent } from './cs-skinfold-site-measure/cs-skinfold-site-measure';
import { CsInfoCardComponent } from './cs-info-card/cs-info-card';
import { CsPageActionButtons } from './cs-page-action-buttons/cs-page-action-buttons';
import { CsHeaderComponent } from './cs-header/cs-header';
import { CsHeaderTitle } from './cs-header-title/cs-header-title';
import { CsHeaderSubtitle } from './cs-header-subtitle/cs-header-subtitle';
import { CsHeaderTitleAction } from './cs-header-title-action/cs-header-title-action';
import { CsHeaderProgressComponent } from './cs-header-progress/cs-header-progress';
import { CsHeaderContent } from './cs-header-content/cs-header-content';
import { CsTaskCalendar } from './cs-task-calendar/cs-task-calendar';
import { CsTaskCalendarDay } from './cs-task-calendar-day/cs-task-calendar-day';
import { CsBottomNavComponent } from './cs-bottom-nav/cs-bottom-nav';
import { CsBadgeComponent } from './cs-badge/cs-badge';
import { CsExerciseStatusBadgeComponent } from './cs-exercise-status-badge/cs-exercise-status-badge';
import { CsStatusIconComponent } from './cs-status-icon/cs-status-icon';
import { CsStatusChipComponent } from './cs-status-chip/cs-status-chip';
import { CsExerciseButtonBarComponent } from './cs-exercise-button-bar/cs-exercise-button-bar';
import { CsExerciseListComponent } from './cs-exercise-list/cs-exercise-list';
import { CsBarButton } from './cs-bar-button/cs-bar-button';
import { CsTextAlert } from './cs-text-alert/cs-text-alert';
import { CsIconButton } from './cs-icon-button/cs-icon-button';
import { CsInputTime } from './cs-input-time/cs-input-time';
import { CsSelectComponent } from './cs-select/cs-select';
import { CsSelectOptionComponent } from './cs-select/cs-select-option';
import { CsProgressChart } from './cs-progress-chart/cs-progress-chart';
import { CsCoachClientsChart } from './cs-coach-clients-chart/cs-coach-clients-chart';
import { CsStepper } from './cs-stepper/cs-stepper';
import { CsDateButtonBar } from './cs-date-button-bar/cs-date-button-bar';
import { CsDateRangeToolbar } from './cs-date-range-toolbar/cs-date-range-toolbar';
import { CsTable } from './cs-table/cs-table';
import { CsTableRow } from './cs-table-row/cs-table-row';
import { CsTableHeaderCell } from './cs-table-header-cell/cs-table-header-cell';
import { CsTableCell } from './cs-table-cell/cs-table-cell';
import { CsRadioDisplayComponent } from './cs-radio-display/cs-radio-display';
import { CsNutritionPlanCard } from './cs-nutrition-plan-card/cs-nutrition-plan-card';
import { CsNutritionStatsRow } from './cs-nutrition-stats-row/cs-nutrition-stats-row';
import { CsVersionDisplayComponent } from './cs-version-display/cs-version-display';
import { CsWorkoutOverviewComponent } from './cs-workout-overview/cs-workout-overview';
import { CsMuscleVolumeComponent } from './cs-muscle-volume/cs-muscle-volume';
import { TutorialHostComponent } from './tutorial/tutorial-host';
import { CsContentComponent } from './cs-content/cs-content';
import { CsBackdropComponent } from './cs-backdrop/cs-backdrop';
import { CsScrollableComponent } from './cs-scrollable/cs-scrollable';
import { CsSliderComponent } from './cs-slider/cs-slider';
import { PopoverHostComponent } from './popover-host/popover-host';
import { VirtualKeyboardComponent } from './virtual-keyboard/virtual-keyboard';
import { ZoomImagePopover } from './zoom-image-popover/zoom-image-popover';
import { CsDayItemsComponent } from './cs-day-items/cs-day-items';
import { CsTrendChartComponent } from './cs-trend-chart/cs-trend-chart';
import { CsTrendBandChartComponent } from './cs-trend-band-chart/cs-trend-band-chart';
import { CsTrendLegendComponent } from './cs-trend-legend/cs-trend-legend';
import { CsBodyCompOverviewComponent } from './cs-body-comp-overview/cs-body-comp-overview';
import { CsCalorieChangeInputComponent } from './cs-calorie-change-input/cs-calorie-change-input';
import { CsNextIntakeCardComponent } from './cs-next-intake-card/cs-next-intake-card';
import { CsTrainingOverviewComponent } from './cs-training-overview/cs-training-overview';
import { CsTabComponent } from './cs-tab/cs-tab';
import { CsTabButtonComponent } from './cs-tab/cs-tab-button';
import { CsSegmentComponent } from './cs-segment/cs-segment';
import { CsSegmentButtonComponent } from './cs-segment/cs-segment-button';
import { CsScreenshotAnnotatorComponent } from './cs-screenshot-annotator/cs-screenshot-annotator';
import { CsFabComponent } from './cs-fab/cs-fab';
import { CsFabButtonComponent } from './cs-fab/cs-fab-button';
import { CsGridComponent } from './cs-grid/cs-grid';
import { CsGridRowComponent } from './cs-grid/cs-grid-row';
import { CsGridColumnComponent } from './cs-grid/cs-grid-column';
import { CsRadioComponent } from './cs-radio/cs-radio-component';
import { CsRadioGroupComponent } from './cs-radio/cs-radio-group-component';
import { CsInputComponent } from './cs-input/cs-input';
import { CsButtonComponent } from './cs-button/cs-button';
import { AlertPopover } from './cs-alert/cs-alert';
import { CopyMealsPopover } from './copy-meals-popover/copy-meals-popover';
import { LoadingHostComponent } from './loading-host/loading-host';
import { CsMenuComponent } from './cs-menu/cs-menu';
import { CsNavComponent } from './cs-nav/cs-nav';
import { CsSplitPaneComponent } from './cs-split-pane/cs-split-pane';
import { CsEmptyStateComponent } from './cs-empty-state/cs-empty-state';
import { CsRollerComponent } from './cs-roller/cs-roller';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DirectivesModule } from 'directives/directives.module';
import { BodyfatInputComponent } from './bodyfat-input/bodyfat-input';
import { HelpCardPopover } from './help-card-popover/help-card-popover';
import { AdvancedMethodsComponent } from './advanced-methods-component/advanced-methods-component';
import { NutritionOptionsComponent } from './nutrition-options-component/nutrition-options-component';
import { CsFoodCardComponent } from './cs-food-card/cs-food-card';
import { CsSupportCardComponent } from './cs-support-card/cs-support-card';
import { CsCoachBannerComponent } from './cs-coach-banner/cs-coach-banner';
import { CsCaptureCoverDirective } from 'directives/cs-capture-cover/cs-capture-cover.directive';
import { CsRestTimerPillComponent } from './cs-rest-timer-pill/cs-rest-timer-pill';
import { CsRestTimerExpandedComponent } from './cs-rest-timer-expanded/cs-rest-timer-expanded';
import { CsStoreBadgesComponent } from './cs-store-badges/cs-store-badges';
import { CsAppInstallSheet } from './cs-app-install-sheet/cs-app-install-sheet';

// every shared component and directive here is both declared and exported, so the list is kept once.
const SHARED_COMPONENTS = [
    CsInputMeasureComponent,
    CsSelectPopover,
    InputPairNavigationDirective,
    CsCaptureCoverDirective,
    ZoomImagePopover,
    ConsentDialogComponent,
    HintBubbleComponent,
    ToastHostComponent,
    PopoverHostComponent,
    LoadingHostComponent,
    CsMenuComponent,
    CsNavComponent,
    CsBackdropComponent,
    TutorialHostComponent,
    CsContentComponent,
    InputCalendarComponent,
    AddMacrosPopover,
    ReschedulePopover,
    CsViewNotesPopover,
    CsLogDetailPopover,
    CsLogDetailContent,
    CsTabContentContainer,
    CsTabContent,
    CsTextarea,
    CsIconComponent,
    CsSpinnerComponent,
    CsCameraViewComponent,
    CsScannerProgressBarComponent,
    CsRepProgressBarComponent,
    CsScannerAnalyzingOverlayComponent,
    CsScannerCameraStageComponent,
    CsScannerShutterBarComponent,
    CsScannerPhotoReelComponent,
    CsScannerHintsComponent,
    CsScannerPermissionDeniedComponent,
    CsScannerModelPickerComponent,
    CsBarcodeTrackerOverlayComponent,
    CsSkeletonComponent,
    HelpIconComponent,
    HelpLinkComponent,
    CsMarkdownComponent,
    CsTextSpinnerComponent,
    VldMessageComponent,
    IngredientList,
    CsRecentMealsEmptyStateComponent,
    ImageUploaderComponent,
    NutrientListComponent,
    MeasuresListComponent,
    MarkdownEditorComponent,
    CsCheckboxComponent,
    CsScrollableComponent,
    CsSliderComponent,
    CsDayItemsComponent,
    CsTrendChartComponent,
    CsTrendBandChartComponent,
    CsTrendLegendComponent,
    CsBodyCompOverviewComponent,
    CsCalorieChangeInputComponent,
    CsNextIntakeCardComponent,
    CsTrainingOverviewComponent,
    CsTabComponent,
    CsTabButtonComponent,
    CsSegmentComponent,
    CsSegmentButtonComponent,
    CsScreenshotAnnotatorComponent,
    CsFabComponent,
    CsFabButtonComponent,
    CsGridComponent,
    CsGridRowComponent,
    CsGridColumnComponent,
    CsRadioComponent,
    CsRadioGroupComponent,
    CsInputComponent,
    CsButtonComponent,
    CsSplitPaneComponent,
    BodyfatInputComponent,
    AlertPopover,
    CopyMealsPopover,
    VirtualKeyboardComponent,
    CsEmptyStateComponent,
    CsRollerComponent,
    CsCardComponent,
    CsCardListComponent,
    CsCardListRowComponent,
    CsCardTitleComponent,
    CsCardHeaderComponent,
    CsCardContentComponent,
    CsNoteComponent,
    CsItemComponent,
    CsItemListComponent,
    CsItemGroupComponent,
    CsItemDividerComponent,
    CsContentDividerComponent,
    CsItemListHeaderComponent,
    CsLabelComponent,
    CsFormField,
    CsToggleComponent,
    CsTooltipComponent,
    CsTooltipPopover,
    CsSkinfoldSiteMeasureComponent,
    CsInfoCardComponent,
    CsPageActionButtons,
    CsHeaderComponent,
    CsHeaderTitle,
    CsHeaderSubtitle,
    CsHeaderTitleAction,
    CsHeaderProgressComponent,
    CsHeaderContent,
    CsTaskCalendar,
    CsTaskCalendarDay,
    CsBottomNavComponent,
    CsBadgeComponent,
    CsExerciseStatusBadgeComponent,
    CsStatusIconComponent,
    CsStatusChipComponent,
    CsExerciseButtonBarComponent,
    CsExerciseListComponent,
    CsBarButton,
    CsTextAlert,
    CsIconButton,
    CsInputTime,
    CsSelectComponent,
    CsSelectOptionComponent,
    CsProgressChart,
    CsCoachClientsChart,
    CsStepper,
    CsDateButtonBar,
    CsDateRangeToolbar,
    CsTable,
    CsTableRow,
    CsTableHeaderCell,
    CsTableCell,
    CsRadioDisplayComponent,
    CsNutritionPlanCard,
    CsNutritionStatsRow,
    CsVersionDisplayComponent,
    CsWorkoutOverviewComponent,
    CsMuscleVolumeComponent,
    HelpCardPopover,
    AdvancedMethodsComponent,
    NutritionOptionsComponent,
    CsFoodCardComponent,
    CsSupportCardComponent,
    CsCoachBannerComponent,
    CsRestTimerPillComponent,
    CsRestTimerExpandedComponent,
    CsStoreBadgesComponent,
    CsAppInstallSheet,
];

@NgModule({
    declarations: SHARED_COMPONENTS,
    imports: [
        CommonModule, DragDropModule, ScrollingModule, DirectivesModule
    ],
    exports: [
        ...SHARED_COMPONENTS,
        DirectivesModule,
    ]
})
export class ComponentsModule { }
